import { useCaptureFbClid } from 'utility/fbclid';
import { useCaptureGClid } from 'utility/gclid';

export const useCaptureAds = (eventId) => {
    useCaptureFbClid(eventId);
    useCaptureGClid(eventId);
};

export const getAdsFromStorage = (eventId) => {
    if (!eventId) return {};
    return {
        fbclid: localStorage.getItem(`fbclid-${eventId}`),
        gclid: localStorage.getItem(`gclid-${eventId}`),
    };
};
